export const CALENDAR_VIEWS = {
  DAY: 'timeGridDay',
  WEEK: 'timeGridWeek',
  MONTH: 'dayGridMonth',
  YEAR: 'multiMonthYear',
  RESOURCE_DAY: 'resourceTimelineDay',
  RESOURCE_WEEK: 'resourceTimelineWeek',
  RESOURCE_MONTH: 'resourceTimelineMonth',
  RESOURCE_YEAR: 'resourceTimelineCustomYear',
  LIST: 'customAgenda'
};

export const TOOLBAR_OPTIONS = [
  {
    label: 'Day',
    value: CALENDAR_VIEWS.DAY
  },
  {
    label: 'Week',
    value: CALENDAR_VIEWS.WEEK
  },
  {
    label: 'Month',
    value: CALENDAR_VIEWS.MONTH
  },
  {
    label: 'Year',
    value: CALENDAR_VIEWS.YEAR
  },
  {
    label: 'List',
    value: 'customAgenda'
  }
];

export const DOUBLE_CLICK_DELAY = 400;
export const DEFAULT_CALENDAR_HEIGHT = 700;
export const DEFAULT_TASK_DURATION = 15;
export const DEFAULT_EVENT_BG_COLOR = '#51ae32';
export const TASK_BG_COLOR = '#3788d8';

export const EVENT_TYPE = {
  EVENT: 'event',
  TASK: 'task'
};

export const RELATION_SUBTYPE = {
  BREEDING: 'breeding',
  LIVESTOCK: 'livestock',
  MEASURE: 'measure',
  TREATMENT: 'treatment'
};

export const EVENT_BG_COLOR = {
  [RELATION_SUBTYPE.BREEDING]: '#e6cc00',
  [RELATION_SUBTYPE.LIVESTOCK]: '#9d9d9d',
  [RELATION_SUBTYPE.MEASURE]: 'brown',
  [RELATION_SUBTYPE.TREATMENT]: 'orange'
};
